<template>

  <v-btn
      class="double-click-confirm-button"
      :class="buttonClass"
      :style="buttonStyle"
      :height="activeButtonHeight"
      :width="buttonWidth"
      :color="buttonColor"
      :disabled="disabled"
      @click="openConfirmView">

    <transition name="fade" mode="out-in">
      <!-- Confirm View (after first click) -->
      <div v-if="isButtonActive" key="confirm" class="confirm-view">
        <div class="confirm-message-title">{{ confirmTitle }}</div>
        <div class="mt-4 confirm-message-text" v-if="confirmMessageText">{{ confirmMessageText }}</div>
        <div class="mt-2 confirm-message-text-line-2" v-if="confirmMessageTextLine2">{{ confirmMessageTextLine2 }}</div>
        <div class="mt-6">
          <v-btn plain color="black" class="mr-12" @click.stop="closeConfirmView">{{ cancelButtonText }}</v-btn>
          <v-btn outlined color="black" @click.stop="confirm">{{ confirmButtonText }}</v-btn>
        </div>
      </div>

      <!-- Default View (resting state) -->
      <div v-else key="default">
        <span v-if="buttonText">{{ buttonText }}</span>
        <v-icon class="ml-2" :color="iconColor" v-if="icon">
          {{ icon }}
        </v-icon>
      </div>
    </transition>
  </v-btn>

</template>

<script>

export default {
  name: 'DoubleClickConfirmButton',

  props: {
    buttonText: {
      type: String,
      default: null,
      required: false
    },
    confirmButtonText: {
      type: String,
      default: 'Confirm',
      required: false
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirmTitle: {
      type: String,
      required: false,
      default: 'Confirm action?'
    },
    confirmMessageText: {
      type: String,
      required: false,
      default: null
    },
    confirmMessageTextLine2: {
      type: String,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    buttonColor: {
      type: String,
      required: false,
      default: 'primary'
    },
    buttonWidth: {
      type: [Number, String],
      required: false,
      default: null
    },
    buttonHeight: {
      type: [Number, String],
      required: false,
      default: 45
    },
    buttonClass: {
      type: String,
      required: false
    },
    buttonStyle: {
      type: String,
      default: null,
      required: false
    },
    icon: {
      type: String,
      required: false,
      default: null
    },
    iconColor: {
      type: String,
      required: false,
      default: 'primary'
    },
    // Delay to reset actively clicked button (in milliseconds)
    resetDelay: {
      type: Number,
      default: 5500 // 5.5 seconds
    }
  },

  data () {
    return {
      isButtonActive: false,
      activeButtonHeight: this.buttonHeight,
      timeoutAction: null
    }
  },

  computed: {
    firstOrder () {
      return ''
    }
  },

  methods: {
    openConfirmView () {
      if (!this.isButtonActive) {
        this.isButtonActive = true
        this.activeButtonHeight = (this.confirmMessageText)
          ? (this.confirmMessageTextLine2) ? 180 : 150
          : 125
        this.timeoutAction = setTimeout(() => {
          this.closeConfirmView()
        }, this.resetDelay)
      }
    },

    closeConfirmView () {
      if (this.isButtonActive) {
        this.isButtonActive = false
        this.activeButtonHeight = this.buttonHeight
        if (this.timeoutAction) {
          clearTimeout(this.timeoutAction)
          this.timeoutAction = null
        }
      }
    },

    confirm () {
      this.$emit('confirmed')
    }
  }
}
</script>

<style scoped>
  .double-click-confirm-button {
    transition: height 0.3s ease-in-out;
    transform-origin: bottom center;
  }

  .double-click-confirm-button .confirm-message-title {
    color: #000000;
    font-size: 1.0rem;
    font-weight: 500;
  }

  .double-click-confirm-button .confirm-message-text {
    color: #2c2c2c;
    font-size: 1.0rem;
    font-weight: 400;
    font-style: italic;
  }

  .double-click-confirm-button .confirm-message-text-line-2 {
    color: #2c2c2c;
    font-size: 0.9rem;
    font-weight: 400;
    font-style: italic;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s ease;
  }

  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }
</style>
